module.exports = __webpack_public_path__ + "assets/img/img-care-banner.9656e34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/care/img-care-banner.jpg
// module id = 1094
// module chunks = 1